module.exports = "/images/vendor/flag-icon-css/flags/1x1/gs.svg?6adf96a85713e8f86ed2dbdf1e1b9444";